'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = require('@/utils');

var _imageCrop = require('@/components/upload-img/image-crop');

var _imageCrop2 = _interopRequireDefault(_imageCrop);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _modal = require('@/components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _config = require('@/config');

var _nav = require('./nav');

var _nav2 = _interopRequireDefault(_nav);

var _imagePath = require('@/mixins/image-path');

var _imagePath2 = _interopRequireDefault(_imagePath);

var _formLayout = require('@/components/form-layout');

var _formLayout2 = _interopRequireDefault(_formLayout);

var _clickoutside = require('@/directives/clickoutside');

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

var _validate = require('@/mixins/validate');

var _validate2 = _interopRequireDefault(_validate);

var _validate3 = require('./validate');

var _validate4 = _interopRequireDefault(_validate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @description 引入表单校验混合
 */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    showNav: {
      type: Boolean,
      default: true
    },
    showLogOut: {
      type: Boolean,
      default: false
    }
  },
  mixins: [_imagePath2.default, _validate2.default],
  provide: function provide() {
    return {
      setVisible: this.setVisible
    };
  },
  data: function data() {
    var _this = this;

    return {
      separator: _config.separator,
      show: false,
      messageCount: null,
      userName: '',
      originalName: '',
      headImg: '',
      phone: '',
      email: '',
      changeUserName: false,
      pageTitle: document.title,
      showScreen: true,
      screenTxt: this.$t('index.fullScreen'),
      messageLabel: function messageLabel(h) {
        return h('div', [h('span', _this.$t('index.message')), h('Badge', {
          props: {
            count: _this.messageCount
          }
        })]);
      },
      value: '', // 输入框默认值为空
      formItem: {
        name: '',
        pictureID: ''
      },
      userID: '',
      changePhoto: false,
      pictureID: '',
      visible: false,
      lang: '',
      langList: [],
      livePlayList: []
    };
  },
  created: function created() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.ruleValidate = _validate4.default;
              _this2.ruleValidate.name[0].message = _this2.$t('index.required');
              _this2.ruleValidate.pictureID[0].message = _this2.$t('index.required');
              _this2.getCurrentUser();
              _this2.getCurrentDiscuss();
              _this2.getLangList();
              _this2.getLiveList();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  directives: {
    clickoutside: _clickoutside2.default
  },
  methods: {
    timeFormat: _utils.timeFormat,
    //获取当前研讨
    getCurrentDiscuss: function getCurrentDiscuss() {
      this.$ajax({
        url: 'api-classes/portal/api/currentinfo',
        method: 'get',
        data: {}
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.data.currentClasses) {
          var classIds = data.data.currentClasses.split(',') || [];
          localStorage.setItem('currentClasses', (0, _stringify2.default)(classIds));
        }
      });
    },
    getLangList: function getLangList() {
      var _this3 = this;

      return _promise2.default.resolve(this.$store.state.langList).then(function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
          var lang;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this3.langList = data;
                  _context2.next = 3;
                  return _this3.$local.getItem('lang');

                case 3:
                  lang = _context2.sent;

                  _this3.lang = (_this3.langList.find(function (item) {
                    return item.value === lang;
                  }) || {}).label;

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    //改变语言
    setLang: function setLang(val) {
      var label = (this.langList.find(function (item) {
        return item.value === val;
      }) || {}).label;
      document.body.setAttribute('lang', val);
      this.lang = label;
      this.$i18n.locale = val;
      localStorage.setItem('lang', val);
      this.$local.setItem('lang', val).then(function () {
        window.location.reload();
      });
    },
    getLiveList: function getLiveList() {
      var _this4 = this;

      this.$ajax({
        url: 'api-classes/portal/open/meeting/listPublicLive',
        method: 'get',
        data: {}
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this4.livePlayList = data.data;
      });
    },

    // 跳转直播
    joinLives: function joinLives(val) {
      window.open(val);
    },

    //获取当前用户信息
    getCurrentUser: function getCurrentUser() {
      var _this5 = this;

      this.$ajax({
        url: 'api-ouser/portal/user/getCurrentUser',
        type: 'GET'
      }).then(function (_ref4) {
        var data = _ref4.data;
        var _data$data = data.data;
        _this5.userID = _data$data.userId;
        _this5.userName = _data$data.name;
        _this5.originalName = _data$data.originalName;
        _this5.phone = _data$data.bindPhone;
        _this5.email = _data$data.email;
        _this5.formItem.name = _data$data.name;
        _this5.pictureID = _data$data.headImg;

        _this5.getImgSrc('headImg', 'headImg', data.data.headImg);
        localStorage.setItem('uname', data.data.originalName + '(' + data.data.name + ')');
        localStorage.setItem('userId', data.data.userId);
      });
    },

    //设为首页
    setHome: function setHome() {
      var url = window.location.href;
      if (document.all) {
        document.body.style.behavior = 'url(#default#homepage)';
        document.body.setHomePage(url);
      } else if (window.sidebar) {
        if (window.netscape) {
          try {
            window.netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');
          } catch (e) {
            this.$Message.warning({
              content: this.$t('index.operateConfig'),
              closable: true,
              duration: 2
            });
          }
        }
        /*setInterval(() => {
          var prefs = Components.classes['@http://mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch)
          prefs.setCharPref('browser.startup.homepage', 'http://www.w3cmark.com')
        }, 500)*/
      } else {
        this.$Message.warning({
          content: this.$t('index.autoSetHomeTips'),
          closable: true,
          duration: 2
        });
      }
    },

    //加入收藏夹
    addCollection: function addCollection() {
      var url = window.location;
      var title = document.title;
      var ua = navigator.userAgent.toLowerCase();

      if (ua.indexOf('360se') > -1) {
        this.$Message.warning({
          content: this.$t('index.favoriteTips'),
          closable: true,
          duration: 2
        });
      } else if (ua.indexOf('msie 8') > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      } else if (document.all) {
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          this.$Message.warning({
            content: this.$t('index.autoSetHomeTips'),
            closable: true,
            duration: 2
          });
        }
      } else if (window.sidebar) {
        window.sidebar.addPanel(title, url, '');
      } else {
        this.$Message.warning({
          content: this.$t('index.autoSetHomeTips'),
          closable: true,
          duration: 2
        });
      }
    },

    //帮助中心
    helpCenter: function helpCenter() {
      this.$router.push({
        name: 'dynamicList',
        query: {
          help: 'help_center'
        }
      });
    },

    //消息
    lookMessage: function lookMessage() {
      //this.messageCount = 0
    },

    //显示箭头卡片
    showArrow: function showArrow(e) {
      this.show = !this.show;
      e.stopPropagation();
      return false;
    },
    handleClose: function handleClose(e) {
      this.show = false;
    },

    /*
    * @description 设置全屏
    * @params fullscreenElement属性返回正处于全屏状态的Element节点，如果当前没有节点处于全屏状态，则返回null
    */
    fullScreen: function fullScreen() {
      //判断可不可以全屏
      var fullscreenEnabled = document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
      var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
      if (fullscreenEnabled) {
        if (fullscreenElement) {
          this.exitFullscreen();
        } else {
          this.setFullscreen();
        }
      } else {
        this.showScreen = false;
      }
    },

    //进入全屏
    setFullscreen: function setFullscreen(element) {
      var el = element instanceof HTMLElement ? element : document.documentElement;
      var rfs = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
      if (rfs) {
        rfs.call(el);
      } else if (window.ActiveXObject) {
        var ws = new window.ActiveXObject('WScript.Shell');
        ws && ws.SendKeys('{F11}');
      }
    },

    //退出全屏
    exitFullscreen: function exitFullscreen() {
      var efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
      if (efs) {
        efs.call(document);
      } else if (window.ActiveXObject) {
        var ws = new window.ActiveXObject('WScript.Shell');
        ws && ws.SendKeys('{F11}');
      }
    },

    //退出
    signOut: function signOut() {
      var _this6 = this;

      this.$ajax({
        url: 'logout',
        type: 'GET'
      }).then(function (res) {
        sessionStorage.clear();
        var lang = localStorage.lang;
        localStorage.clear();
        localStorage.lang = lang;
        _this6.$Message.success(_this6.$t('login.logout'));
        _this6.$router.push('/');
      });
    },

    /*
     * @description 修改用户名
     */
    updateName: function updateName() {
      var _this7 = this;

      this.validate('formCustom').then(function (validate) {
        if (!validate) return;
        //修改用户名
        _this7.$ajax({
          url: 'api-ouser/portal/user',
          method: 'put',
          data: {
            userId: _this7.userID,
            name: _this7.formItem.name
          }
        }).then(function (res) {
          _this7.changeUserName = false;
          _this7.getCurrentUser();
        });
      });
    },

    /*
     * @description 修改头像
     */
    updatePhoto: function updatePhoto() {
      var _this8 = this;

      this.$refs.imageCrop.onFileUpload().then(function (res) {
        if (res.success) {
          _this8.formItem.pictureID = res.data.fileID;
          _this8.validate('formCustom').then(function (validate) {
            if (!validate) return;
            //修改图片
            _this8.$ajax({
              url: 'api-ouser/portal/user',
              method: 'put',
              data: {
                userId: _this8.userID,
                headImg: _this8.formItem.pictureID
              }
            }).then(function (res) {
              _this8.changePhoto = false;
              _this8.getCurrentUser();
            });
          });
        } else {
          _this8.$Message.error(res.message ? res.message : _this8.$t('index.uploadError'));
        }
      });
    },
    cancel: function cancel() {
      this.changeUserName = false;
    },
    photoCancel: function photoCancel() {
      this.changePhoto = false;
    },

    // 修改密码
    resetPasswords: function resetPasswords() {
      this.$router.push({
        path: '/resetPasswords'
      });
      this.opacitySize = 'none';
    },

    // 修改手机号
    resetPhone: function resetPhone() {
      this.$router.push({
        path: '/resetPhone'
      });
      this.opacitySize = 'none';
    },

    // 修改邮箱
    resetEmail: function resetEmail() {
      this.$router.push({
        path: '/resetEmail'
      });
      this.opacitySize = 'none';
    },

    // 消息的总数
    setMessageCount: function setMessageCount(count) {
      this.messageCount = count;
    },
    setVisible: function setVisible() {
      this.visible = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$Message.destroy();
  },

  computed: {
    noInIE: function noInIE() {
      return !/trident/ig.test(navigator.userAgent);
    }
  },
  components: {
    IconFont: _iconfont2.default,
    Nav: _nav2.default,
    Modal: _modal2.default,
    FormLayout: _formLayout2.default,
    ImageCrop: _imageCrop2.default,
    Message: _message2.default
  }
};
/*
 * @description 引入表单校验配置参数
 */